import React from 'react';

import { Table, TableBody } from '@mui/material';
import { useContainer } from 'unstated-next';

import { useDeleteModal } from '../hooks/useDeleteModal';
import { useTemplateStatusModal } from '../hooks/useTemplateStatusModal';
import DeleteTemplateModal from '../Modals/DeleteTemplateModal';
import UpdateTemplateStatusModal from '../Modals/TemplateStatusModal';
import TemplateContainer from '../TemplateContext';
import { ActionType } from '../types';
import PublishedTemplateRow from './PublishedTemplateRow';
import TemplatesTableHeader from './TemplatesTableHeader';

const PublishedTemplates: React.FC = () => {
    const { publishedTemplates, deletePublishedTemplate, unpublishTemplate } = useContainer(TemplateContainer);
    const { deleteModalIsOpen, openDeleteModal, templateToDelete, closeDeleteModal } = useDeleteModal();
    const { statusModalIsOpen, openPublishModal, templateIdToPublish, closePublishModal } = useTemplateStatusModal();

    const handleDelete = () => {
        const templateId = templateToDelete?.sid;

        if (templateId) {
            closeDeleteModal();
            deletePublishedTemplate(templateId);
        }
    };

    const handleUnpublish = () => {
        if (templateIdToPublish) {
            closePublishModal();
            unpublishTemplate(templateIdToPublish);
        }
    };

    return (
        <Table>
            <TemplatesTableHeader />
            <TableBody>
                {publishedTemplates.map((publishedTemplate) => (
                    <PublishedTemplateRow openDeleteModal={openDeleteModal} openPublishModal={openPublishModal} template={publishedTemplate} key={publishedTemplate.sid} />
                ))}
            </TableBody>

            <DeleteTemplateModal handleDelete={handleDelete} deleteModalIsOpen={deleteModalIsOpen} closeDeleteModal={closeDeleteModal} templateToDelete={templateToDelete} />
            <UpdateTemplateStatusModal actionType={ActionType.Unpublish} handleUpdate={handleUnpublish} statusModalIsOpen={statusModalIsOpen} closePublishModal={closePublishModal} />
        </Table>
    );
};

export default PublishedTemplates;
